import http, { type ApiEnvelope } from "./http";
import { toFormParams } from "@/utils/form";

export interface CatalogNode {
  id: number;
  name: string;
  pid: number;
  invisible: number;
  children?: CatalogNode[];
}

export interface CatalogData {
  id: number;
  uid: number;
  name: string;
  pid: number;
  invisible: number;
  pid_list: string;
  level: number;
  sort: number;
  key: string;
  md5: string;
  created_at: number;
  updated_at: number;
  deleted_at: number | null;
}

export interface CatalogPayload {
  tree: CatalogNode[];
  list: Record<string, CatalogNode>;
}

export interface AddCatalogRequest {
  pid: number;
  invisible: number;
  name: string;
}

export interface UpdateCatalogRequest {
  id: number;
  pid: number;
  invisible: number;
  name: string;
}

export function fetchCatalogList() {
  return http.get("/CatalogList") as Promise<ApiEnvelope<CatalogPayload>>;
}

export function createCatalog(payload: AddCatalogRequest) {
  return http.post(
    "/Catalog",
    toFormParams(payload)
  ) as Promise<ApiEnvelope<CatalogData>>;
}

export function updateCatalog(payload: UpdateCatalogRequest) {
  return http.put(
    "/Catalog",
    toFormParams(payload)
  ) as Promise<ApiEnvelope<boolean>>;
}

export function deleteCatalog(id: number | string) {
  return http.delete("/Catalog", {
    data: toFormParams({ id })
  }) as Promise<ApiEnvelope<{ delete_num: number }>>;
}

export function sortCatalog(items: Array<{ id: string | number; sort: string | number }>) {
  return http.put(
    "/CatalogSort",
    toFormParams({ data: JSON.stringify(items) })
  ) as Promise<ApiEnvelope<boolean>>;
}
